import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Text } from '@famly/mf_data-display_text';
const StyledDescription = styled.div `
    display: inline-block;
`;
const InnerContentImg = styled.img `
    ${props => props.mute
    ? css `
                  filter: grayscale(100%);
              `
    : ''}
`;
export const InnerContent = (props) => {
    const { item, emptyImageSrc } = props;
    return (_jsxs(_Fragment, { children: [_jsx(InnerContentImg, { src: item.image ? item.image : emptyImageSrc, alt: item.name, mute: item.mute }), _jsxs(StyledDescription, { children: [_jsx(Text, { variant: "body", color: "n0", children: item.name }), item.flair ? (_jsx(Text, { variant: "body-small", component: "span", color: "n0", children: item.flair })) : null] })] }));
};
